import React from 'react';
import WorkshopsUserEventsTable from '../Common/MoodleEventBooking/WorkshopsUserEventsTable';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';

export default function WorkshopsPreviousEventsPage() {
  const { email } = useAuthenticateUser();

  if (!email) {
    return <div className="p-4">Unable to determine user email.</div>;
  }

  return (
    <div className="p-4 h-full min-h-0 flex flex-col gap-4">
      <div>
        <h1 className="text-2xl font-semibold">Previous Events</h1>
        <p className="text-sm opacity-70">
          View completed workshop events.
        </p>
      </div>

      <div className="flex-1 min-h-0">
        <WorkshopsUserEventsTable
          email={email}
          defaultTimePreset="past_365"
          allowedDirection="past"
          restrictToUserAssociation={false}
          eventRouteBase="/workshops/previous-events"
        />
      </div>
    </div>
  );
}